<div class="row padding-for-support-button header-padding">
  <div class="col-12">
    <ng-content></ng-content>
  </div>
</div>
